import * as React from "react";
const NewsClockBlueSs = (props) => (
  <svg
    width={props.width}
    height={props.height}
    viewBox="0 0 11 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.41413 0.683371C2.57961 0.550983 2.60644 0.309511 2.47405 0.144027C2.34167 -0.0214577 2.10019 -0.048288 1.93471 0.0840993L0.65564 1.10736C0.490156 1.23974 0.463326 1.48122 0.595713 1.6467C0.7281 1.81218 0.969573 1.83901 1.13506 1.70663L2.41413 0.683371Z"
      fill={props.color}
    />
    <path
      d="M9.06529 0.0840993C8.89981 -0.048288 8.65833 -0.0214577 8.52595 0.144027C8.39356 0.309511 8.42039 0.550983 8.58587 0.683371L9.86494 1.70663C10.0304 1.83901 10.2719 1.81218 10.4043 1.6467C10.5367 1.48122 10.5098 1.23974 10.3444 1.10736L9.06529 0.0840993Z"
      fill={props.color}
    />
    <path
      d="M5.88372 3.96513C5.88372 3.75321 5.71193 3.58141 5.5 3.58141C5.28808 3.58141 5.11628 3.75321 5.11628 3.96513V6.11696C5.11628 6.28006 5.05396 6.437 4.94208 6.55567L4.19755 7.34537C4.05217 7.49956 4.05932 7.74242 4.21351 7.88779C4.36771 8.03317 4.61056 8.02602 4.75594 7.87183L5.50047 7.08214C5.74662 6.82105 5.88372 6.47578 5.88372 6.11696V3.96513Z"
      fill={props.color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.5 0.511641C2.46243 0.511641 0 2.97407 0 6.01164C0 9.04921 2.46243 11.5116 5.5 11.5116C8.53757 11.5116 11 9.04921 11 6.01164C11 2.97407 8.53757 0.511641 5.5 0.511641ZM0.767442 6.01164C0.767442 3.39792 2.88628 1.27908 5.5 1.27908C8.11372 1.27908 10.2326 3.39792 10.2326 6.01164C10.2326 8.62536 8.11372 10.7442 5.5 10.7442C2.88628 10.7442 0.767442 8.62536 0.767442 6.01164Z"
      fill={props.color}
    />
  </svg>
);
export default NewsClockBlueSs;
